import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import './lib/marker-clusterer';


$(document).foundation();



/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
let prevScrollpos = window.scrollY;

const elNavBar = document.getElementById("navbar");
const fullwidthDropDowns = document.getElementsByClassName("main--full-width");

window.addEventListener("scroll", function () {
  const currentScrollPos = window.scrollY;

  // Clear all scroll direction classes
  elNavBar.classList.remove("going-up", "going-down", "top-floor");

  if (currentScrollPos === 0) {
    elNavBar.classList.add("top-floor");
  } else if (currentScrollPos < prevScrollpos || currentScrollPos < 50) {
    elNavBar.classList.add("going-up");

    for (const fullwidthDropDown of fullwidthDropDowns) {
      fullwidthDropDown.classList.remove("lift");
    }
  } else {
    elNavBar.classList.add("going-down");

    for (const fullwidthDropDown of fullwidthDropDowns) {
      fullwidthDropDown.classList.add("lift");
    }
  }

  prevScrollpos = currentScrollPos;
});




/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
//  var prevScrollpos = window.pageYOffset;
//  window.onscroll = function() {
//    var currentScrollPos = window.pageYOffset;

//    const navbar = document.getElementById("navbar");

//    if (prevScrollpos > currentScrollPos ||  window.pageYOffset < 50) {

//     if(window.pageYOffset == 0) {
    
//       navbar.classList.remove('header--scroll-background');
      
//     } else {     

//      navbar.style.top = "0";

//      if (prevScrollpos > 174) {
//       navbar.classList.add('header--scroll-background');
//      }

//     }

//    } else {
//      navbar.style.top = "-175px";
//    }

//    prevScrollpos = currentScrollPos;

//  }


   // Dynamic form

   $('body').on('submit', '.dynamic_form', function submitCB(event) {              
       
        event.preventDefault(); 

        var $self = $(this);
        $(".alert.alert-success").remove();
        // $("button[type=submit]", $self).prop("disabled", true);
        $self.find( "button[type=submit]" ).prop("disabled", true);
        
    
        $.ajax({
          type: "post",
          dataType: "json",
          data: $(this).serialize(),
          success: function (response) {

            $("ul.errors.help-block", $self).remove();
            $(".has-error", $self).removeClass("has-error");
    
            if (response.success && response.finished) {
              $self[0].reset();
    
              // var $successMessage = $("<div>", { "class": "alert alert-success" })
              //   .append("<p>Form submitted successfully</p>", { "class": "lead" });
    
              // $("#contactFormFields").hide();
              // $("#contactFormSuccess").fadeIn();
              // $("#contactFormSuccess")[0].scrollIntoView();

              $self.closest( ".contactFormFields" ).hide();
              $self.closest( ".contactFormFields" ).next( ".contactFormSuccess" ).fadeIn();
    
            } else if (response.errors) {
    
              for (var key in response.errors) {
                if (!response.errors.hasOwnProperty(key)) continue;
    
                var messages = response.errors[key];
                var $errors = $("<ul>", { "class": "errors help-block" });
                for (var i = 0; i < messages.length; i++) {
                  var $li = $("<li>");
                  $li.html(messages[i]);
                  $errors.append($li);
                }
    
                var $input = $self.find( "*[name=" + key + "], *[name='" + key + "[]']" );

                // console.log( $self.find( "*[name=" + key + "], *[name='" + key + "[]']" ) );
    
                const $formGroup = $input.parents(".form-group");
                $formGroup.addClass("has-error");
    
                $formGroup.append($errors);
              }
            }
    
            if (response.honeypot) {
              var honeypotInput = $("input[name^=freeform_form_handle_]", $self);
              honeypotInput.attr("name", response.honeypot.name);
              honeypotInput.attr("id", response.honeypot.name);
              honeypotInput.val(response.honeypot.hash);
            }

            // $self.find( "button[type=submit]" ).prop("disabled", false);
            $('button[type="submit"]').prop('disabled', false);

          },
        });
    
  });


  // TOGGLE BACKGROUND ON NAVBAR ON MOBILE

  const navbarHamburgerBtn = document.getElementById("hamburger");
  const navbarContainer = document.getElementById("navbar");  

  navbarHamburgerBtn.addEventListener("click", (event) => {
    navbarContainer.classList.toggle("header--has-mobile-background");   
  });



  // TOGGLE NAVBAR HIDE ON MOBILE WHEN ANCHOR LINK IS CLICKED (FOR USE ON LANDING PAGE ONLY)
  const navbarLinks = navbarContainer.getElementsByClassName("nav-link-anchor");
  const navbarMainMenu = document.getElementById("main-menu");
  const navbarMobileTitleBar = navbarContainer.querySelector(".title-bar");

  console.log(navbarMobileTitleBar);
  console.log(navbarMobileTitleBar.style.display);

  for (const navbarLink of navbarLinks) {
     
      navbarLink.addEventListener("click", function(e) {
        
        // e.preventDefault();      

        if(navbarMobileTitleBar.style.display != "none") {         

          navbarMainMenu.classList.remove("show-menu"); 
          navbarContainer.classList.toggle("header--has-mobile-background");  
          navbarHamburgerBtn.classList.remove("is-active");  
        }      
        
      })

  }
  